import { useContext, useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import { useFormik } from "formik";
import * as yup from "yup";
import { GlobalContext } from "../../context/Context";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router";
import { useApiCall } from "../../component/custom-hooks/api-call";

const Login = () => {
  let { state, dispatch } = useContext(GlobalContext);
  const [btnLoad, setBtnLoad] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigation = useNavigate();
  const [step, setStep] = useState(1); // 1 = email step, 2 = password step
  const [showLoader, setShowLoader] = useState(false);
  const apiCall = useApiCall();

  const validationSchema = yup.object({
    email: yup
      .string("Enter Valid Value")
      .email("Enter Valid Value")
      .required("This Field is Required"),
    password: yup
      .string("Enter Valid Value")
      .min(6, "Minimum 6 Character Required")
      .required("This Field is Required"),
  });
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "password123",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setBtnLoad(true);
      let apiData = {
        email: values.email,
        password: values.password,
      };
      try {
        let response = await apiCall({
          method: "post",
          url: "login",
          data: apiData,
        });

        let user = {};
        Object?.keys(response.data).forEach((e) => {
          let newKey = e;
          if (e?.slice(0, 5) === "auth_") {
            newKey = e.replace("auth_", "");
          }
          user = { ...user, [newKey]: response.data[e] };
        });

        console.log("user", user);

        let mainRole =
          user?.user_role == "1" ||
          user?.user_role == "2" ||
          user?.user_role == "3"
            ? "admin"
            : user.employee_role == "5" || user.employee_role == "6"
            ? "lead"
            : "user";
        let subRole =
          user?.department == "13"
            ? "hr"
            : user.department == "14"
            ? "finance"
            : "";
        let dashboardRole = user?.user_type == "6" ? "single" : "all";
        user = { mainRole, subRole, dashboardRole, ...user };

        // remember email if checked
        if (rememberMe) {
          localStorage.setItem("rememberEmail", values.email);
        } else {
          localStorage.removeItem("rememberEmail");
        }

        localStorage.setItem("token", response.access_token);
        localStorage.setItem("user", JSON.stringify(user));

        dispatch({
          type: "USER_LOGIN",
          payload: user,
          token: response.access_token,
        });
        setBtnLoad(false);
        navigation("/dashboard");
      } catch (error) {
        console.warn("Error", error);
        setErrorMessage(error.response.data.error);
        setBtnLoad(false);
      }
    },
  });

  const [userEditedEmail, setUserEditedEmail] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleEmailChange = (e) => {
    // Only set true when typing manually (not autofill/select)
    if (e.nativeEvent?.inputType) {
      setUserEditedEmail(true);
    }
    formik.handleChange(e);
  };

  // reset only if user actually typed new email
  useEffect(() => {
    if (userEditedEmail) {
      if (step === 2) {
        setStep(1);
        formik.setFieldValue("password", "");
      }
      setUserEditedEmail(false);
    }
  }, [formik.values.email]);

  // ⬇️ Hide error when email or password changes
  useEffect(() => {
    if (errorMessage) {
      setErrorMessage(null);
    }
  }, [formik.values.email, formik.values.password]);

  useEffect(() => {
    if (step === 2 && formik.values.email) {
      // force keep selected email, prevent Chrome reset
      document.getElementById("email").value = formik.values.email;
    }
  }, [step]);

  // handle step change
  const handleNextStep = () => {
    if (!formik.values.email) return; // require email
    setShowLoader(true);
    setTimeout(() => {
      setShowLoader(false);
      setStep(2); // show password
    }, 2500);
  };

  // 🔹 Prefill email if remembered
  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberEmail");
    if (savedEmail) {
      formik.setFieldValue("email", savedEmail);
      setRememberMe(true);
    }
  }, []);

  // BOTH VIDEO LOAD AT SAME TIME
  // Inside your component:
  const leftVideoRef = useRef(null);
  const rightVideoRef = useRef(null);
  const [leftLoaded, setLeftLoaded] = useState(false);
  const [rightLoaded, setRightLoaded] = useState(false);
  const [allReady, setAllReady] = useState(false);

  const passwordRef = useRef();

  useEffect(() => {
    if (leftLoaded && rightLoaded) {
      setAllReady(true);
    }
  }, [leftLoaded, rightLoaded]);

  useEffect(() => {
    if (allReady) {
      const left = leftVideoRef.current;
      const right = rightVideoRef.current;

      const playVideos = async () => {
        try {
          await left?.play();
          await right?.play();
        } catch (err) {
          console.warn("Autoplay blocked, waiting for user interaction", err);

          // fallback: wait for user click to start
          const handleUserInteraction = async () => {
            await left?.play();
            await right?.play();
            window.removeEventListener("click", handleUserInteraction);
          };
          window.addEventListener("click", handleUserInteraction);
        }
      };

      playVideos();
    }
  }, [allReady]);

  return (
    <div className={Style.login_main}>
      <div className={Style.login_main_body}>
        <div className={Style.login_row}>
          <div className={`${Style.login_col} ${Style.left}`}>
            <div className={Style.login_main_video}>
              <video
                ref={leftVideoRef}
                muted
                loop
                playsInline
                preload="auto"
                poster={`${state.basePath}/login/login_logo.png`}
                onLoadedData={() => setLeftLoaded(true)}
              >
                <source
                  src={`${state.basePath}/login/login_logo.mp4`}
                  type="video/mp4"
                />
              </video>
            </div>
            <div className={Style.login_main_hd}>
              <h6>
                <span>4x faster </span>
                Build for
                <b> Human Intelligence </b>
                <br />
                jaw-dropping
                <b> Technology</b>
              </h6>
            </div>
          </div>

          <div className={`${Style.login_col} ${Style.right}`}>
            <div className={`${Style.loginCard} ${Style.liquidGlass}`}>
              <div className={Style.form_video}>
                <video
                  ref={rightVideoRef}
                  muted
                  loop
                  playsInline
                  preload="auto"
                  poster={`${state.basePath}/login/login_logo.png`}
                  onLoadedData={() => setRightLoaded(true)}
                >
                  <source
                    src={`${state.basePath}/login/login_logo.mp4`}
                    type="video/mp4"
                  />
                </video>
              </div>
              <div className={Style.form_shade}></div>
              <div className={Style.liquidGlass_effect}></div>
              <div className={Style.formContent}>
                <div className={Style.logo}>
                  <img
                    src={`${state?.basePath}/login/form-logo.png`}
                    alt="Opraviq"
                  />
                </div>
                <div className={Style.formHeading}>
                  <h2>Sign in with Company ID</h2>
                </div>

                <form
                  className={`${Style.loginForm} ${
                    step === 2 ? Style.loginFormActive : null
                  } ${errorMessage ? Style.error : null}`}
                  onSubmit={formik.handleSubmit}
                >
                  {/* Company ID Field */}
                  <div
                    className={`${Style.loginForm_feild} ${
                      formik.values.email ? Style.active : ""
                    }`}
                  >
                    <input
                      // autoComplete="off"
                      autoComplete="username"
                      type="email"
                      name="email"
                      id="email"
                      value={formik.values.email}
                      onChange={handleEmailChange}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // prevent form submission or reload
                          handleNextStep();
                        }
                      }}
                    />
                    <label htmlFor="email">Company ID</label>

                    {step !== 2 && (
                      <>
                        <div
                          className={Style.loginForm_feildBtn}
                          onClick={handleNextStep}
                        >
                          {showLoader ? (
                            <CircularProgress
                              sx={{ color: "#fff" }}
                              size={20}
                            />
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="white"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 14L14 10L10 6L8.6 7.4L10.2 9H6V11H10.2L8.6 12.6L10 14ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z" />
                            </svg>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  {/* Password Field (only show at step 2) */}
                  {step === 2 && (
                    <>
                      <div className={Style.loginForm_lineBreak}></div>
                      <div
                        className={`${Style.loginForm_feild} ${
                          formik.values.password ? Style.active : ""
                        }`}
                      >
                        <input
                          ref={passwordRef}
                          // autoComplete="new-password"
                          autoComplete="current-password"
                          type="password"
                          name="password"
                          id="password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor="password">Enter Password</label>

                        <button
                          className={Style.loginForm_feildBtn}
                          type="submit"
                        >
                          {btnLoad ? (
                            <CircularProgress
                              sx={{ color: "#fff" }}
                              size={20}
                            />
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="white"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 14L14 10L10 6L8.6 7.4L10.2 9H6V11H10.2L8.6 12.6L10 14ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z" />
                            </svg>
                          )}
                        </button>
                      </div>
                    </>
                  )}

                  {errorMessage && (
                    <div className={Style.loginForm_error}>
                      <p>
                        check the account information you entered and try again.
                      </p>

                      <a href="#">
                        <span>Forgot password?</span>
                      </a>
                    </div>
                  )}
                </form>

                <div className={Style.formFooter}>
                  <div className={Style.formFooterRemember}>
                    <label htmlFor="remember">
                      <input
                        id="remember"
                        type="checkbox"
                        checked={rememberMe}
                        onChange={() => setRememberMe(!rememberMe)}
                      />
                      Remember me
                    </label>
                  </div>

                  <div className={Style.formFooterForget}>
                    <a href="#">Forgotten your ID or password?</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={Style.login_main_foot}>
        <div className={Style.lmf_col}>
          <p>Copyright © 2025 Opraviq Inc. All rights reserved.</p>
        </div>

        <div className={Style.lmf_col}>
          <ul>
            <li>
              <a href="#">Privacy Policy</a>
            </li>
            <li>
              <span>|</span>
            </li>
            <li>
              <a href="#">Terms of Use</a>
            </li>
          </ul>
        </div>

        <div className={`${Style.lmf_col} text-right`}>
          <p>
            Powered by <a href=""> Opraviq</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
